/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ModeratorCompanyReadiness,
  ModeratorReadinessQuestion,
  ModeratorReadinessQuestionRequest,
  ModeratorsReadinessCompaniesListParams,
  PatchedModeratorReadinessQuestionRequest
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Each company's latest assessment (score / band / timestamp).
 * @summary Per-company readiness
 */
export const moderatorsReadinessCompaniesList = (
    params?: ModeratorsReadinessCompaniesListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ModeratorCompanyReadiness[]>(
      {url: `/api/v1/moderators/readiness/companies/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsReadinessCompaniesListQueryKey = (params?: ModeratorsReadinessCompaniesListParams,) => {
    return [`/api/v1/moderators/readiness/companies/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsReadinessCompaniesListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsReadinessCompaniesList>>, TError = unknown>(params?: ModeratorsReadinessCompaniesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsReadinessCompaniesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsReadinessCompaniesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsReadinessCompaniesList>>> = ({ signal }) => moderatorsReadinessCompaniesList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsReadinessCompaniesList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsReadinessCompaniesListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsReadinessCompaniesList>>>
export type ModeratorsReadinessCompaniesListQueryError = unknown

/**
 * @summary Per-company readiness
 */
export const useModeratorsReadinessCompaniesList = <TData = Awaited<ReturnType<typeof moderatorsReadinessCompaniesList>>, TError = unknown>(
 params?: ModeratorsReadinessCompaniesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsReadinessCompaniesList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsReadinessCompaniesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * GET returns the full question set with points, weights and status. POST creates a question (super moderator only).
 * @summary List or create readiness questions (moderator)
 */
export const moderatorsReadinessQuestionsList = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ModeratorReadinessQuestion[] | ModeratorReadinessQuestion>(
      {url: `/api/v1/moderators/readiness/questions/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsReadinessQuestionsListQueryKey = () => {
    return [`/api/v1/moderators/readiness/questions/`] as const;
    }

    
export const getModeratorsReadinessQuestionsListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsReadinessQuestionsList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsReadinessQuestionsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsReadinessQuestionsList>>> = ({ signal }) => moderatorsReadinessQuestionsList(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsReadinessQuestionsListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsReadinessQuestionsList>>>
export type ModeratorsReadinessQuestionsListQueryError = void

/**
 * @summary List or create readiness questions (moderator)
 */
export const useModeratorsReadinessQuestionsList = <TData = Awaited<ReturnType<typeof moderatorsReadinessQuestionsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsReadinessQuestionsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * GET returns the full question set with points, weights and status. POST creates a question (super moderator only).
 * @summary List or create readiness questions (moderator)
 */
export const moderatorsReadinessQuestionsCreate = (
    moderatorReadinessQuestionRequest: ModeratorReadinessQuestionRequest,
 ) => {
      
      
      return customInstance<ModeratorReadinessQuestion[] | ModeratorReadinessQuestion>(
      {url: `/api/v1/moderators/readiness/questions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorReadinessQuestionRequest
    },
      );
    }
  


export const getModeratorsReadinessQuestionsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsCreate>>, TError,{data: ModeratorReadinessQuestionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsCreate>>, TError,{data: ModeratorReadinessQuestionRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsReadinessQuestionsCreate>>, {data: ModeratorReadinessQuestionRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsReadinessQuestionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsReadinessQuestionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsReadinessQuestionsCreate>>>
    export type ModeratorsReadinessQuestionsCreateMutationBody = ModeratorReadinessQuestionRequest
    export type ModeratorsReadinessQuestionsCreateMutationError = void

    /**
 * @summary List or create readiness questions (moderator)
 */
export const useModeratorsReadinessQuestionsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsCreate>>, TError,{data: ModeratorReadinessQuestionRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsReadinessQuestionsCreate>>,
        TError,
        {data: ModeratorReadinessQuestionRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsReadinessQuestionsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Moderator-side readiness CRUD + reporting.
 * @summary Update or delete a readiness question (super moderator)
 */
export const moderatorsReadinessQuestionsUpdate = (
    id: number,
    moderatorReadinessQuestionRequest: ModeratorReadinessQuestionRequest,
 ) => {
      
      
      return customInstance<ModeratorReadinessQuestion | void>(
      {url: `/api/v1/moderators/readiness/questions/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: moderatorReadinessQuestionRequest
    },
      );
    }
  


export const getModeratorsReadinessQuestionsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsUpdate>>, TError,{id: number;data: ModeratorReadinessQuestionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsUpdate>>, TError,{id: number;data: ModeratorReadinessQuestionRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsReadinessQuestionsUpdate>>, {id: number;data: ModeratorReadinessQuestionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsReadinessQuestionsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsReadinessQuestionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsReadinessQuestionsUpdate>>>
    export type ModeratorsReadinessQuestionsUpdateMutationBody = ModeratorReadinessQuestionRequest
    export type ModeratorsReadinessQuestionsUpdateMutationError = void

    /**
 * @summary Update or delete a readiness question (super moderator)
 */
export const useModeratorsReadinessQuestionsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsUpdate>>, TError,{id: number;data: ModeratorReadinessQuestionRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsReadinessQuestionsUpdate>>,
        TError,
        {id: number;data: ModeratorReadinessQuestionRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsReadinessQuestionsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Moderator-side readiness CRUD + reporting.
 * @summary Update or delete a readiness question (super moderator)
 */
export const moderatorsReadinessQuestionsPartialUpdate = (
    id: number,
    patchedModeratorReadinessQuestionRequest: PatchedModeratorReadinessQuestionRequest,
 ) => {
      
      
      return customInstance<ModeratorReadinessQuestion | void>(
      {url: `/api/v1/moderators/readiness/questions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedModeratorReadinessQuestionRequest
    },
      );
    }
  


export const getModeratorsReadinessQuestionsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsPartialUpdate>>, TError,{id: number;data: PatchedModeratorReadinessQuestionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsPartialUpdate>>, TError,{id: number;data: PatchedModeratorReadinessQuestionRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsReadinessQuestionsPartialUpdate>>, {id: number;data: PatchedModeratorReadinessQuestionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsReadinessQuestionsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsReadinessQuestionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsReadinessQuestionsPartialUpdate>>>
    export type ModeratorsReadinessQuestionsPartialUpdateMutationBody = PatchedModeratorReadinessQuestionRequest
    export type ModeratorsReadinessQuestionsPartialUpdateMutationError = void

    /**
 * @summary Update or delete a readiness question (super moderator)
 */
export const useModeratorsReadinessQuestionsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsPartialUpdate>>, TError,{id: number;data: PatchedModeratorReadinessQuestionRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsReadinessQuestionsPartialUpdate>>,
        TError,
        {id: number;data: PatchedModeratorReadinessQuestionRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsReadinessQuestionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Moderator-side readiness CRUD + reporting.
 * @summary Update or delete a readiness question (super moderator)
 */
export const moderatorsReadinessQuestionsDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<ModeratorReadinessQuestion | void>(
      {url: `/api/v1/moderators/readiness/questions/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getModeratorsReadinessQuestionsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsDestroy>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsReadinessQuestionsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsReadinessQuestionsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsReadinessQuestionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsReadinessQuestionsDestroy>>>
    
    export type ModeratorsReadinessQuestionsDestroyMutationError = void

    /**
 * @summary Update or delete a readiness question (super moderator)
 */
export const useModeratorsReadinessQuestionsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsReadinessQuestionsDestroy>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsReadinessQuestionsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsReadinessQuestionsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Count of companies per band (from each company's latest assessment), the number of currently active questions, and an `activatedCompanies` tile for the dashboard. A company counts as activated when it is approved, has a trade profile (corridor side + at least one trade role) and its latest readiness assessment passed.
 * @summary Readiness summary (moderator dashboard)
 */
export const moderatorsReadinessSummaryRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/readiness/summary/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsReadinessSummaryRetrieveQueryKey = () => {
    return [`/api/v1/moderators/readiness/summary/`] as const;
    }

    
export const getModeratorsReadinessSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsReadinessSummaryRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsReadinessSummaryRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsReadinessSummaryRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsReadinessSummaryRetrieve>>> = ({ signal }) => moderatorsReadinessSummaryRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsReadinessSummaryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsReadinessSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsReadinessSummaryRetrieve>>>
export type ModeratorsReadinessSummaryRetrieveQueryError = unknown

/**
 * @summary Readiness summary (moderator dashboard)
 */
export const useModeratorsReadinessSummaryRetrieve = <TData = Awaited<ReturnType<typeof moderatorsReadinessSummaryRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsReadinessSummaryRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsReadinessSummaryRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



